import { render, staticRenderFns } from "./ItemPriceWithApiDto.vue?vue&type=template&id=d7aab18e&scoped=true&"
import script from "./ItemPriceWithApiDto.vue?vue&type=script&lang=ts&"
export * from "./ItemPriceWithApiDto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7aab18e",
  null
  
)

export default component.exports